import { Box, Button, CircularProgress } from '@mui/material';
import { createRoot, Root } from 'react-dom/client';
import { localeAtom } from '@repo/i18n';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';

class BilberryStripePayButton extends BilberryCustomElement {
    private _handleSubmit: ((e: any) => void) | undefined = undefined;
    private root: Root | null = null;

    static get observedAttributes() {
        return ['isloading', 'handleSubmit'];
    }

    constructor() {
        super();
        this.root = createRoot(this._mountPoint);
    }

    get isloading(): boolean {
        return this.getAttribute('isloading') === 'true';
    }

    set isloading(value: boolean | string | null | number) {
        const next =
            value === true ||
            value === 'true' ||
            value === '' || // attribute with no value => truthy
            value === 1 ||
            value === '1';

        if (next) {
            this.setAttribute('isloading', 'true');
        } else {
            this.removeAttribute('isloading');
        }
        // attributeChangedCallback will trigger renderWidget
    }

    get handleSubmit() {
        return this._handleSubmit;
    }

    set handleSubmit(value: ((e: any) => void) | undefined) {
        this._handleSubmit = value;
        this.renderWidget();
    }

    attributeChangedCallback() {
        this.renderWidget();
    }

    protected renderWidget(): void {
        const { t } = localeAtom.subject.value;

        // finally we need to wrap our application in a StylesProvider
        this.root?.render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <Box sx={{ position: 'relative' }}>
                    <Button
                        onClick={this.handleSubmit}
                        color="primary"
                        variant="contained"
                        className="bilberry-stripe-payment"
                        disabled={this.isloading}
                        sx={{
                            mt: 2,
                        }}
                    >
                        {t.buyNow}
                    </Button>
                    {this.isloading && (
                        <CircularProgress sx={{ position: 'absolute', top: 10, left: 25 }} />
                    )}
                </Box>
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement(): void {
    // Both the activities and the timeslots production bundle evaluate this module (via
    // StripePaymentWrapper -> initStripeWidget); a second define on one page would throw.
    if (!customElements.get('bilberry-stripe-pay-button')) {
        customElements.define('bilberry-stripe-pay-button', BilberryStripePayButton);
    }
}
